import { Binary } from "@angular/compiler";
import { Documento } from "../../../app/catalagos/entidades/documento";

export class CreditoDocumentos {
    
    id: number;
    descripcion: string;
    imagen: Binary[];
    idCredito: number;
    idArchivo: string;
    idCatalogo: Documento;

    archivo: Binary[];
    prefijo:string;
    idTipoDocumento:number;
    idDocumento: number;
  
    constructor(tipo?: number){
      if (tipo == 1)
        this.prefijo="comprobante";
      else if (tipo == 0)
        this.prefijo="G";
      else
        this.prefijo="C";
        this.archivo = this.imagen;
      }
    /*idArchivo: number;
    descripcion: string;
    imagen: Binary[];*/

    /*constructor(descripcion: string, imagen: Binary[]) {
        this.descripcion = descripcion;
        this.imagen = imagen;
      }*/
}
